import { DatesProvider } from '@mantine/dates';
import type { ReactNode } from 'react';

import { useLang } from './useLang';

/** Keeps `@mantine/dates` pickers (month names, week start) in sync with the UI language. */
export function DatesLocaleProvider({ children }: { children: ReactNode }) {
  const lang = useLang();
  return <DatesProvider settings={{ locale: lang, firstDayOfWeek: 1, weekendDays: [0, 6] }}>{children}</DatesProvider>;
}
